import { render } from "./CreateNewCallQueueTimeSlot.vue?vue&type=template&id=8e1b2bb2&scoped=true"
import script from "./CreateNewCallQueueTimeSlot.vue?vue&type=script&lang=js"
export * from "./CreateNewCallQueueTimeSlot.vue?vue&type=script&lang=js"

import "./CreateNewCallQueueTimeSlot.vue?vue&type=style&index=0&id=8e1b2bb2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1b2bb2"]])

export default __exports__